import { storyblokEditable } from "@storyblok/react";
import { Link } from "react-router";

const LinkableCard = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)} className="font-display">
      <div className="card card-linkable">
        <div className="card-image">
          <img src={blok.cardimage.filename} alt={blok.cardimage.alt} />
        </div>
        <div className="card-detail">
          <h3>{blok.title}</h3>
          <p className="desc">{blok.description}</p>
        </div>
        <Link to={`/${blok.extlink.cached_url}`}></Link>
      </div>
    </div>
  );
};

export default LinkableCard;
